<template>
  <div class="self_adaption">
    <div class="self_adaption_main">
      <el-form ref="form" :model="form" label-width="96px" label-position="right" class="FormFlex"
               style="justify-content: space-between;">
        <div class="FormBtn" style="width:100%;display:flex;justify-content:flex-end;">
          <el-button size="medium" type="success" @click="addData()">新增</el-button>
        </div>
      </el-form>
      <el-table :data="formList" border style="width: 100%;" :header-cell-style="{ background: 'rgb(238,249,253)' }">
        <el-table-column type="index" align="center" width="60" label="序号"></el-table-column>
        <el-table-column prop="title" align="center" label="发布会主题">
          <template slot-scope="scope">
            <div >{{ scope.row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="intro" align="center" label="发布会简介" >
            <template v-slot="scope">
              <div class="description_pre">{{scope.row.intro}}</div>
            </template>

        </el-table-column>
        <el-table-column align="center" label="发布会状态" width="120">
          <template slot-scope="scoped">
            {{ scoped.row.status ? '已结束' : '待发布' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220">
          <template slot-scope="scoped">
            <el-tag style="margin:5px 5px" @click="addData(scoped.row.id)" size="small" class="cursor">发布会信息编辑</el-tag>
            <el-tag style="margin:0px 5px" @click="Details('edit', scoped.row)" size="small" class="cursor">内容编辑</el-tag>
            <el-tag style="margin:0px 5px" @click="Details('see', scoped.row)" size="small" class="cursor">预览发布</el-tag>
            <el-tag style="margin:0px 5px" @click="Details('del', scoped.row)" size="small" class="cursor">删除</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align:right;margin:20px 0px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="form.current" :page-sizes="[10, 20, 50, 100]" :page-size="form.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {surveyDelete, surveyList} from '@/api/axiosUrl';

  export default {
    name: 'Progress',
    components: {},
    data() {
      return {
        form: {
          current: 1,
          size: 10
        },
        total: 0,
        formList: [],
      };
    },
    created() {
      this.renderData();
    },
    methods: {
      addData(id) {
        this.$router.push({path: '/addList', query: {id: id}});
      },
      //进入页面去渲染数据
      renderData() {
        surveyList(this.form).then(res => {
          this.formList = res.data.records;
          this.total = Number(res.data.total);
        });
      },
      Details(flag, data) {
        var _this = this
        if (flag === 'edit') {
          this.$router.push({
            path: "/edit",
            query: {
              id: data.id,
            },
          });
        } else if (flag === 'del') {
          _this.$confirm('此操作将永久删除, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            surveyDelete({id: data.id}).then(res => {
              if (res.status === 200) {
                _this.Messager('删除成功', 'success')
                _this.renderData()
              } else {
                _this.Messager('删除失败', 'error')
              }
            });
          })
        } else if (flag === 'see') {
          this.$router.push({
            path: "/preview",
            query: {
              id: data.id,
            },
          });
        }
      },
      edit() {
        alert(1)
      },
      handleCurrentChange(val) {
        this.form.current = Number(val)
        this.renderData()
      },
      handleSizeChange(val) {
        this.form.size = Number(val)
      },
      //警告提示
      Messager(text, messageType) {
        this.$message({message: text, type: messageType})
      }
    }
  };
</script>

<style scoped>
  .description_pre{
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>
